/* unplugin-vue-components disabled */import { render } from "./CompanyConfig.vue?vue&type=template&id=75304f76"
import script from "./CompanyConfig.vue?vue&type=script&lang=js"
export * from "./CompanyConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__